import React, { useState } from 'react';

import Link from 'next/link';
import { useSelector } from 'react-redux';

import { IState } from 'store';
import { IConfigProps } from 'store/modules/config';

import * as S from './styles';

export default function MobileNavigationTree() {
  const [showCategories, setShowCategories] = useState(false);
  const [showCategoriesChildren, setShowCategoriesChildren] = useState(null);
  const [showChildrensChildren, setShowChildrensChildren] = useState(null);

  const { categories, brands } = useSelector<IState, IConfigProps>(
    state => state.config,
  );

  return (
    <S.Container
      className={`mobile-navigation-tree${showCategories ? ' show' : ''}`}
    >
      <strong
        onClick={() => setShowCategories(state => !state)}
        className="categories-list-header"
      >
        Categorias
        {showCategories ? (
          <span className="chevron-icon down" title="Esconder subcategorias" />
        ) : (
          <span className="chevron-icon right" title="Mostrar subcategorias" />
        )}
      </strong>

      {showCategories && (
        <ul className="father-categories-list">
          {categories.map(fatherCategory => (
            <>
              <li
                key={fatherCategory.id}
                className="father-category"
                onClick={() => {
                  if (
                    fatherCategory.filhos.length > 0 &&
                    fatherCategory.id !== showCategoriesChildren
                  )
                    setShowCategoriesChildren(fatherCategory.id);
                  else setShowCategoriesChildren(null);
                }}
              >
                <a
                  href={`/categoria/${fatherCategory.permalink}`}
                  target="_self"
                >
                  <span className="category-name">{fatherCategory.nome}</span>
                </a>

                {fatherCategory.filhos.length > 0 ? (
                  <>
                    {showCategoriesChildren === fatherCategory.id ? (
                      <span
                        className="chevron-icon down"
                        title="Esconder subcategorias"
                      />
                    ) : (
                      <span
                        className="chevron-icon right"
                        title="Mostrar subcategorias"
                      />
                    )}
                  </>
                ) : (
                  <span className="fake-icon" />
                )}
              </li>

              {fatherCategory.filhos.length > 0 &&
                showCategoriesChildren === fatherCategory.id && (
                  <ul className="children-categories-list">
                    {fatherCategory.filhos.map(firstChildrenCategory => (
                      <>
                        <li
                          key={firstChildrenCategory.id}
                          className="children-category"
                          onClick={() => {
                            if (
                              firstChildrenCategory.filhos.length > 0 &&
                              firstChildrenCategory.id !== showChildrensChildren
                            )
                              setShowChildrensChildren(
                                firstChildrenCategory.id,
                              );
                            else setShowChildrensChildren(null);
                          }}
                        >
                          <a
                            href={`/categoria/${firstChildrenCategory.permalink}`}
                            target="_self"
                          >
                            <span className="category-name">
                              {firstChildrenCategory.nome}
                            </span>
                          </a>
                          {firstChildrenCategory.filhos.length > 0 ? (
                            <>
                              {showChildrensChildren ===
                              firstChildrenCategory.id ? (
                                <span
                                  className="chevron-icon down"
                                  title="Esconder subcategorias"
                                />
                              ) : (
                                <span
                                  className="chevron-icon right"
                                  title="Mostrar subcategorias"
                                />
                              )}
                            </>
                          ) : (
                            <span className="fake-icon" />
                          )}
                        </li>

                        {firstChildrenCategory.filhos.length > 0 &&
                          showChildrensChildren ===
                            firstChildrenCategory.id && (
                            <ul className="children-childrens-list">
                              {firstChildrenCategory.filhos.map(
                                childrensCategory => (
                                  <li
                                    key={childrensCategory.id}
                                    className="children-category"
                                  >
                                    <a
                                      href={`/categoria/${childrensCategory.permalink}`}
                                    >
                                      {childrensCategory.nome}
                                    </a>
                                  </li>
                                ),
                              )}
                            </ul>
                          )}
                      </>
                    ))}
                  </ul>
                )}
            </>
          ))}

          {brands && brands.length > 0 && (
            <>
              <li
                key={categories.length + 1}
                className="father-category brands"
                onClick={() => {
                  if (showCategoriesChildren !== categories.length + 1)
                    setShowCategoriesChildren(categories.length + 1);
                  else setShowCategoriesChildren(null);
                }}
              >
                <span className="category-name">Marcas</span>

                {showCategoriesChildren === categories.length + 1 ? (
                  <span className="chevron-icon down" title="Esconder marcas" />
                ) : (
                  <span className="chevron-icon right" title="Mostrar marcas" />
                )}
              </li>

              {showCategoriesChildren === categories.length + 1 && (
                <ul className="children-categories-list">
                  {brands?.map(brand => (
                    <li
                      key={brand.id}
                      className="children-category"
                      onClick={() => setShowCategories(false)}
                    >
                      <Link
                        href={
                          brand.permalink ? `/marca/${brand.permalink}` : '/'
                        }
                        passHref
                      >
                        <a target="_self">
                          <span className="category-name">{brand.nome}</span>
                        </a>
                      </Link>
                    </li>
                  ))}
                </ul>
              )}
            </>
          )}
        </ul>
      )}
    </S.Container>
  );
}
